import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Lumen Reel',
    description:
        'An infinite portfolio reel of editorial, fashion, and brand photography. Hover to feel it, click to view full.',
    url: 'https://lumenreel.com'
}
